import { useEffect, useState } from 'react';

// This is the width at which the current insights app switches to the "narrow" view with the collapsed
// sidebar. It's a temporary value, moved from the legacy/webapp package.
export const LEGACY_NARROW_SCREEN_MAX_WIDTH = 991;

/**
 * This hook checks if the width of the page is smaller than the established max width
 * for the narrow view.
 */
export const useIsScreenNarrow = (): boolean => {
  const [isScreenNarrow, setIsScreenNarrow] = useState(false);

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth < LEGACY_NARROW_SCREEN_MAX_WIDTH) {
        setIsScreenNarrow(true);
      } else {
        setIsScreenNarrow(false);
      }
    };

    window.addEventListener('resize', handler);
    handler();

    return () => window.removeEventListener('resize', handler);
  }, []);

  return isScreenNarrow;
};
